import { useTranslation } from 'react-i18next';

import { Mail } from 'lucide-react';

import { SUPPORT_EMAIL } from './contactMail';
import { useContactMail } from './useContactMail';
import { Card, PageHeader } from '../../components';

/**
 * 문의하기(`/more/docs/contact`) — 안내 한 문단, 메일 버튼, 받는 주소.
 *
 * 버튼 아래에 받는 주소를 적는다 — 버튼만 두면 어디로 가는지 누르기 전에 알 수 없고, 메일
 * 앱이 없을 때 주소는 사라지는 토스트에만 남는다. 본문의 `support@muzly.io` 도 같은 동작의
 * 링크다 — 여는 방법은 `useContactMail` 이 갖는다.
 *
 * 약관·방침은 시행일별 버전이 있어 자기 화면이고(`features/policy`), 자주 묻는 질문은
 * 아코디언이다(`FaqPage`).
 */

const CONTACT_CTA =
  'mt-6 flex h-[54px] w-full items-center justify-center gap-2 rounded-full bg-black text-base font-bold text-white';

export const ContactPage = () => {
  const { t } = useTranslation();
  const { mailAction, withMailLinks } = useContactMail();

  return (
    <div className="flex min-h-dvh flex-col bg-background pb-10">
      <PageHeader title={t('web.more.docs.contact.title')} />
      <div className="px-[18px] pt-2">
        <Card className="px-5 py-6">
          <p className="whitespace-pre-line break-keep text-sm leading-relaxed text-bk-800">
            {withMailLinks(t('web.more.docs.contact.body'))}
          </p>
        </Card>

        {mailAction(
          CONTACT_CTA,
          <>
            <Mail className="h-5 w-5" aria-hidden="true" />
            {t('web.more.contactCta')}
          </>,
        )}
        <p className="mt-3 select-text text-center text-sm text-bk-600">
          {SUPPORT_EMAIL}
        </p>
      </div>
    </div>
  );
};
